/**
 * return undefined || 0(means exceed) || >0
 *
 */
export function getAttemptVal(res) {
    res = res || {};
    let attempt;
    if (Object.prototype.hasOwnProperty.call(res.result||{}, 'attempt')) { // BFF
        attempt = res.result.attempt;
    } else if (typeof res.result !== 'object'){ // BFFSC: number
        attempt = res.result;
    }
    return attempt;
}

